/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { TagControllerService } from './services/tag-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    TagControllerService,
    ApiConfiguration
  ],
})
export class CustomersTagsModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersTagsModule> {
    return {
      ngModule: CustomersTagsModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersTagsModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersTagsModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
